import React, { useState } from "react";
import logo from "../images/logo.png";
import WhiteButton from "../components/WhiteButton";
import TransparentButton from "../components/TransparentButton";
import { Link } from "react-router-dom";
import Menu from "../images/Menu 1.png";
import HighlightButton from "./buttons/HighlightButton";
import BorderLessButton from "./buttons/BorderlessButton";
import BlackButton from "./buttons/BlackButton";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <nav className="flex py-6 items-center px-4 xl:px-8  w-full justify-between">
        <div>
          <Link to="https://northstarz.ai/">
            <img src={logo} className="h-10" alt="logo" />
          </Link>
        </div>

        <div className="flex md:hidden">
          <img
            src={Menu}
            alt="menu"
            onClick={toggleMenu}
            className="cursor-pointer"
          />
        </div>

        {/* <div className="hidden md:flex items-center gap-4 xl:gap-8 text-sm xl:ml-20">
          <Link to="https://northstarz.ai/about">
            <p className="font-thicboi text-base font-semibold  text-white hover:text-amber-200 cursor-pointer">
              ABOUT US
            </p>
          </Link>
          <Link to="https://northstarz.ai/pricing">
            <p className="font-thicboi text-base font-semibold  text-white hover:text-amber-200 cursor-pointer">
              PRICING
            </p>
          </Link>
          <a target="_blank" href="https://blog.northstarz.ai/">
            <p className="font-thicboi text-base font-semibold  text-white hover:text-amber-200 cursor-pointer">
              RESOURCES
            </p>
          </a>
        </div> */}

        <div className="hidden md:flex items-center space-x-4">
          <HighlightButton text={"Get started free"} to={"/checkout"} />
          <BlackButton text={"Get a demo"} to={"https://northstarz.ai/contact"} />
          <BorderLessButton
            text={"Log In"}
            to={"https://northstarz.ai/login"}
            style={{ padding: "0 10px 0 0" }}
          />
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden flex flex-col items-center space-y-4 py-4 bg-transparent text-white">
          {/* <Link to="/about" onClick={toggleMenu}>
            <p className="font-thicboi cursor-pointer">ABOUT US</p>
          </Link>
          {!window.location.href.includes("checkout") && (
            <Link to="/pricing">
              <p className="font-thicboi text-white cursor-pointer">PRICING</p>
            </Link>
          )}
          <a target="_blank" href="https://blog.northstarz.ai/">
            <p className="font-thicboi cursor-pointer">RESOURCES</p>
          </a> */}
          <WhiteButton text={"Get started free"} to={"/checkout"} />
          <Link to="/demo" onClick={toggleMenu}>
            <p className="font-thicboi cursor-pointer">Get a demo</p>
          </Link>
          <TransparentButton text={"Log In"} />
        </div>
      )}
    </>
  );
};

export default Header;
